import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down-right2",
  "use": "arrow-down-right2-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"arrow-down-right2\"><path d=\"M4.586 7.414L21.172 24h-7.171a2 2 0 1 0 0 4h12A2 2 0 0 0 28 26h.001V14a2 2 0 1 0-4 0v7.172L7.415 4.586C7.024 4.195 6.513 4 6.001 4s-1.024.195-1.414.586a2 2 0 0 0 0 2.828z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-down-right2.svg
// module id = OcKS
// module chunks = 1